import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetcher from "../redux/books/thunk/fetcher";
import Book from "./Book";
import BookAddForm from "./BookAddForm";
import BooksFilter from "./BooksFilter";

export default function BooksContainer() {
  const dispatch = useDispatch();
  const { books } = useSelector((state) => state.books);
  const filters = useSelector((state) => state.filters);
  const { search, status } = filters;

  //Load books from server
  useEffect(() => {
    dispatch(fetcher);
  }, [dispatch]);

  return (
    <main className="py-12 2xl:px-6">
      <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
        <div className="order-2 xl:-order-1">
          <BooksFilter />

          <div className="lws-bookContainer">
            {books
              //Switch between all and featured books
              .filter((book) => {
                if (status === "Featured") {
                  return book.featured;
                }
                return true;
              })
              //Search book by its name
              .filter((book) => {
                if (search.length > 0) {
                  return book?.name
                    .toLowerCase()
                    .includes(search.toLowerCase());
                }
                return true;
              })
              .map((book) => (
                <Book
                  book={book}
                  key={book.id}
                />
              ))}
            {books.length === 0 && <p>No books found</p>}
          </div>
        </div>

        <BookAddForm />
      </div>
    </main>
  );
}
